"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const size_const_1 = __importDefault(require("../choices/size.const"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const modalFooter = {
    buttonSpacing: size_const_1.default.default2x,
    paddingVertical: size_const_1.default.default2x,
    paddingHorizontal: size_const_1.default.medium,
    paddingSmallHorizontal: size_const_1.default.default2x,
    shadowSize: size_const_1.default.shadowSmall,
    shadowColor: color_const_1.default.cloudyBlue300,
};
exports.default = modalFooter;
